/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 252);
/******/ })
/************************************************************************/
/******/ ({

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

var _commonsHelper = __webpack_require__(3);
/**
 * Helper module for the Registration page
 */
module.exports = $.extend(_commonsHelper, {
	
	/**
	 * Remove the server side validation error messages
	 */
	removeValidationErrors: function(el) {
		$('ul.errors', el.parentNode).empty();		
	},
		
	/**
	 * get label of a form field
	 */
	getLabel: function(field) {
		return $.trim($(field).siblings('.form-label').text());
	}
});

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(253);
module.exports = __webpack_require__(261);


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Initialize all sub-modules
 */

/* eslint-disable */

jQuery(function($) {
	var helper = __webpack_require__(3);
	
	var $form = $('.registration-form-container form');

	var modules = {
		form: __webpack_require__(32),
		username: __webpack_require__(254),
		password: __webpack_require__(255),
		countryRegion: __webpack_require__(59),
		account: __webpack_require__(256),
		accountCustomerShowHide: __webpack_require__(257),
		allMarketsShowHide: __webpack_require__(258),
		excludedMarketsShowHide: __webpack_require__(259),
		tracking: __webpack_require__(260)
	};

	// params is supposed to be defined in the page.
	helper.initPage({
		$form: $form, 
		modules: modules
	});
});



/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

var _helper = __webpack_require__(23);

/**
 * Username module for the Registration page
 */
module.exports = {

	/**
	 * initialize
	 */	
	init: function(params) {
		var self = this;
		
		self.$el = $('#credential\\.username');
		var $el = self.$el;
		
		self.$resultContainer = $el.siblings('.availability-result-container');		
		self.$suggestions = $('.suggestions', self.$resultContainer);
		self.$messageContainer = $('.availability-message', self.$resultContainer);
		self.$errorIcon = $el.siblings('.text-error-icon');
		self.$verifiedIcon = $el.siblings('.text-verified-icon');
		self.$linkContainer = $('.check-availability-container');
		self.serviceUri = 'user/username';
		
		/* Helper funtion to replace tokens in a String when a data object 
		*  Token names are the keys in the data object 
		*/
		String.prototype.bind = function(data) {
			var s = this.toString();
			for(var key in data) {
				var re = new RegExp('\\{' + key + '\\}', 'gm');
				 s = s.replace(re, data[key]);
			}
			
			return s;
		};

		// when suggestions.changed happens, we need to re-hook 'change' event on those suggestions  
		self.bindSuggestionsChange();		
		
		/* Event listener for hiding or showing the 'Check availability' link */
		self.bindInput(params);
	},
	
	/**
	 * Bind the 'change' event when suggenstions has been populated
	 */
	bindSuggestionsChange: function() {
		var self = this;
		self.$suggestions.on('suggestions.changed', function() {
			$('input[type=radio]', this).on('change', function() {
				self.$el.val($(this).val());
				self.checkUserNameAvailability();
			});
		});	
	},
	
	/* Update the availability result message */
	toggleAvailabilityMessage: function($messageContainer, available) {
		$('.username-taken', $messageContainer).toggleClass('hidden', available);
		$('.username-available', $messageContainer).toggleClass('hidden', !available);
	},
	
	/* Popluate suggetions if there are any */
	buildSuggestions: function($parent, names) {
		
		if(!$.isArray(names) || names.length === 0) {
			return;
		}
		
		/* As of jQuery 1.12, empty() method removes event listeners */
		$parent.empty();
		var tml = "<label for='suggestion-{index}'><input type='radio' name='suggested-usernames' value='{value}' id='suggestion-{index}'><span>{value}</span></label>";
		for(var i = 0; i < names.length; ++i) {
    		var label = tml.bind({
    			index: i,
    			value: names[i]
    		});
    		
    		$parent.append(label);
		}
		
		$parent.trigger('suggestions.changed');
	},
	
	
	/* Check username availability */
	checkUserNameAvailability: function() {
		var self = this, 
			$el = self.$el, 
			$suggestions = self.$suggestions,
			username = $.trim($el.val());
		
		if(username === '') {
			return $.Deferred();
		}
		
		var promise = _helper.ajaxPost(self.serviceUri, {username: username});
		
		promise.then($.proxy(self.handleResult, self));
		
		return promise;
	},
	
	/*
	 * Handle the result of availability checking
	 */
	handleResult: function(data, reloading) {
		var self = this, 
			$el = self.$el, 
			$suggestions = self.$suggestions,
			$errorIcon = self.$errorIcon,
			$verifiedIcon = self.$verifiedIcon;
		
		if(!$.isPlainObject(data)) return;
		
		$el.val(data.username);
		$el.toggleClass('has-error', !data.available);
		$el.toggleClass('verified', data.available);
		self.$resultContainer.removeClass('hidden');
		$errorIcon.toggleClass('hidden', data.available);
		$verifiedIcon.toggleClass('hidden', !data.available);
		if(!data.available) {
			self.buildSuggestions($suggestions, data.suggestions);			
		}else{
			$suggestions.empty();
		}
		self.toggleAvailabilityMessage(self.$messageContainer, data.available);		
	},
		
	/**
	 * Bind input and propertychange to username field
	 */
	bindInput: function(params) {
		var self = this, 
			$el = self.$el;
		
		$el.prop('handled', []);
				
		$el.on(_helper.isIE() ? 'keyup' : 'input' , function(e) {
			var val = $el.val();
			self.handleChange(params.minUsernameLength, val);
		});
		
		self.handleResult(params.availabilityResult, true);
	},
	
	/**
	 * handle the value change on username field
	 */
	handleChange: function(minLength, val) {
		var self = this, $linkContainer = self.$linkContainer;
		
		var hiding = val.length < minLength;
		$linkContainer.toggleClass('hidden', hiding);		
		var link = $('.check-availability');
		link.off();
		if(!hiding) {
			link.on('click', function() {
				self.checkUserNameAvailability();
			});
			_helper.removeValidationErrors(this);
		}
		self.resetField();
	},
	
	/**
	 * reset username field to normal style
	 */
	resetField: function() {
		var self = this, 
			$el = self.$el, 
			$resultContainer = self.$resultContainer, 
			$errorIcon = self.$errorIcon,
			$verifiedIcon = self.$verifiedIcon;
		
		$el.removeClass('has-error');
		$el.removeClass('verified');
		$errorIcon.removeClass('hidden').addClass('hidden');
		$resultContainer.removeClass('hidden').addClass('hidden');
		$verifiedIcon.removeClass('hidden').addClass('hidden');		
	}
	
};

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

var _form = __webpack_require__(32);

/**
 * Password field sub module
 */
module.exports = {
		
	/**
	 * initialize
	 */
	init: function(params) {
		var self = this;
		self.params = params;
		
		this.setUpShowPassword();
		this.checkErrors();
	},
	
	/**
	 * Attach events for show/hide password fields
	 */
	setUpShowPassword: function() {
		var self = this;
		
     	$('#toggle-password').change(function(e) {
     		$('#password, #confirmPassword').toggleClass('hidden');
    		$('#shadow-password, #shadow-confirmPassword').toggleClass('hidden');
    		if($.isFunction($.fn.placeholder)) {
	    		var $form = self.params.$form;
	    		var $passwordFields = e.target.checked === true ? $('input[id^=shadow]', $form) :  $('input[type=password]', $form);
	    		_form.initPasswordFielsPlaceholder($passwordFields);
    		}
     	});

 		$('#password, #confirmPassword, #shadow-password, #shadow-confirmPassword').on('keyup', function(e) {
						
			var $shadow = $('#shadow-'+this.id);
			var $nonShadow = $('#'+this.id.replace('shadow-', ''));			
			var $this = $(this);
			
			if($shadow.val() != $this.val()) {
				$shadow.val($(this).val());
			}
			
			if($nonShadow.val() != $this.val()) {
				$nonShadow.val($(this).val());
			}
			
 		});
	},
	
	/**
	 * check if the password fields have error
	 */
	checkErrors: function() {
		$('#shadow-password').toggleClass('has-error', $('#password').hasClass('has-error'));
		$('#shadow-confirmPassword').toggleClass('has-error', $('#confirmPassword').hasClass('has-error'));
	}
};

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

var _helper = __webpack_require__(23);

/**
 * Module for accountNumber and accountValidation fields
 */
module.exports = {
	
	/**
	 * initilize the account fields to hook events 
	 */
	init: function(params) {
		var self = this,
			req_attr = 'rs-account-request',
			$accountFields = $('[' + req_attr + ']');
		
		self.params = params;				
		self.req = {};
		self.$companyNames = $('#company\\.name,#company\\.nameKana,#company\\.name2', params.$form);
		self.isJP = $('#company\\.nameKana').length > 0;

		self.$companyNames.each(function(index, field) {
			var accountVerified = params.accountVerified === true;
			var hasValue = $.trim(field.value).length > 0;
			
			self.disableEnableFields(field, accountVerified, hasValue);
		});
		
		$(document).on('accounts.populated', $.proxy(self.onAccountChange, self));
		
		$accountFields.on('change', $.proxy(self.onAccontsFieldsChange, self, $accountFields, req_attr));
		
		self.toggleHearAbout(params.accountVerified === true);
	},
	
	/**
	 * show/hide the hearAbout field
	 */
	toggleHearAbout: function(hide) {
		var self = this;
		$('#hearAbout', self.params.$form).parents('.form-item').toggleClass('hidden', hide);
	},	
	
	/**
	 * When account fields changed
	 */
	onAccontsFieldsChange: function($accountFields, req_attr, e) {		
		var self = this, 
			$emptyFields = $accountFields.filter(function() { return $(this).val() === ''; }),
			$target = $(e.target);

		if($emptyFields.length === 0) {
			$accountFields.each(function(index, field) {
				var k = $(field).attr(req_attr);
				self.req[k] = field.value;
			});
			$(document).trigger('accounts.populated');
		}else if($.trim($target.val()) === '') {
			$target.removeClass('has-error verified');
			$target.siblings('.text-error-icon,.text-verified-icon').addClass('hidden');
			self.$companyNames.each(function(index, field) {
				self.disableEnableFields(field, false);
			});			
		}
	},
	
	/**
	 * handler for account fields change
	 */
	onAccountChange: function(e) {
		var self = this, 
			serviceUri = 'accountDetails';
		
		var promise = _helper.ajaxPost(serviceUri, self.req);
		promise.then($.proxy(self.handleResult, self));
	},

	/**
	 * handle the result of accountDetails ajax call 
	 */
	handleResult: function(response) {
		
		var self = this;
		
		$('.unkown-account-message-container').toggleClass('hidden', response.valid === true);
		$('[rs-account-request]')
			.toggleClass('has-error', response.valid === false)
			.toggleClass('verified', response.valid === true)
			.siblings('.text-error-icon').toggleClass('hidden', response.valid === true)
			.siblings('.text-verified-icon').toggleClass('hidden', response.valid === false);
		
		response.addresses = response.addresses || [];
		
		if(response.addresses.length > 1) {
			self.doSelectAddressDialog(response);
		}else {
			if(response.addresses.length === 1) {
				self.setSelectedAddress(response, 0);
			}
			self.populateFields(response);
			self.toggleHearAbout(response.valid === true);
		}
		
	},
	
	/**
	 * disable/enable company names fields
	 */
	disableEnableFields: function(field, accountVerified, hasValue) {
		var self = this, $field = $(field), isJP = self.isJP;
		switch(field.id) {
		    case 'company.name':
		    	var disabled = accountVerified && hasValue;
		    	$field.prop('readonly', disabled);
		    	$field.toggleClass('disabled', disabled);
		        break;
		    case 'company.name2':
		    	var disabled = accountVerified && !isJP;
		    	$field.prop('readonly', disabled);
		    	$field.toggleClass('disabled', disabled);
		        break;
		    case 'company.nameKana':
		    	var disabled = accountVerified;
		    	$field.prop('readonly', disabled);
		    	$field.toggleClass('disabled', disabled);
		        break;
		    default:
		        break;
		}		
	},	
	
	/**
	 * populate the form fields with json result 
	 */
	populateFields: function(data) {
		var self = this, $form = self.params.$form;
		
		var $fields = $('input[name]:not([class~=hidden]):not([rs-account-request]):not([type=hidden]):not([name^=credential\\.]),select[name]:not([class~=hidden]):not([rs-account-request])', $form);
		
		$fields.each($.proxy(self.populateField, self, data));
	},
	
	/**
	 * put value to single field
	 */
	populateField: function(data, index, field) {
		var self = this;
		
		var value = self.getDataByFieldName(field.name, data),
			$field = $(field);
		var fieldTag = field.tagName.toLowerCase();
		var fieldType = field.type.toLowerCase();
		
		// $.trim takes care of null/undefined as well
		// ignore the field if value is empty/null/undefined
		var isEmpty = $.trim(value).length === 0;
		if(!isEmpty) {
			$(field).val(value).trigger('change');
		}
		
		// disable/enable 'Company name' and 'Trading As' fields
		self.disableEnableFields(field, data.valid === true, !isEmpty);
	},
		
	/**
	 * get value from json response by form field name
	 */
	getDataByFieldName: function(fieldName, data) {
		if(!$.isPlainObject(data)) {
			return;
		}
		var self = this, pos = fieldName.indexOf('.');
		if(pos > -1) {		
			data = data[fieldName.slice(0,pos)];
			return self.getDataByFieldName(fieldName.slice(pos+1), data);
		}
		
		return data[fieldName];
	},
			
	/**
	 * show dialog for selecting an address 
	 * and set the selected one into the json result
	 */
	doSelectAddressDialog: function(response) {
		var self = this, $dlg = $("#addresses-dialog");
				
		self.setupDialog($dlg, response);
				
		$dlg.modal('show');		
	},
	
	/**
	 * center the dialog
	 */
	centerDialog: function($dlg) {

		var $d = $('.modal-dialog', $dlg),
			$w = $(window),
			top = $w.scrollTop();

		$d.css({
			'margin-top':($w.height()-$d.outerHeight())/2
		});
	},		
	
	/**
	 * configure dialog
	 */
	setupDialog: function($dlg, response) {

		var self = this, $container = $('.addresses-container', $dlg);
		
		self.populateAddresses($dlg, response, $container);
		
		self.installEventHandlers($dlg, response, $container);
		
    	//initially select the first address
		var val = self.lastSel || '0';
		$('input[type=radio][value=' + val + ']', $container).parents('.address-container').click();
	},
	
	/**
	 * populate the addresses list 
	 */
	populateAddresses: function($dlg, response, $container) {
		var self = this, 
			$contact = $('.contact-id-container .contact-id', $dlg),
			addresses = response.addresses,
			$row;
		
		// display contact ID
		$contact.text(response.contact);
		
		//dynamically add  addresses
		$container.empty();
		for(var i = 0; i < addresses.length; i++) {
			if(i%2 === 0) {
				$row = $('<div class="row"/>').appendTo($container);
			}
			self.buildAddressCell(addresses[i], i).appendTo($row);
		}
		$container.prepend($container);
	},
	
	/**
	 * Install event handler
	 */
	installEventHandlers: function($dlg, response, $container) {
		var self = this, 
			$selectButton = $('button.select-button', $dlg),
			$addressContainer = $('.address-container', $dlg);

		// hook click event to select an address
		$addressContainer.off('click').on('click', function(e) {
    		
			$addressContainer.removeClass('selected');
    		
    		var $radio = $('input[type=radio]', this);
    	
    		if(e.target !== $radio[0]) {
    			$radio.click();
    			$(this).addClass('selected');
    		}
    	});
		
		// Handle 'click' event on select button
		$selectButton.off('click').on('click', function() {
			self.select($dlg, response, $container);
		});
    	
    	// hook dblclick event to select an address
    	$('.address-container', $dlg).on('dblclick', function(e) {
    		$(this).trigger('click');
    		$selectButton.trigger('click');
    	});
    	
    	$dlg.on('shown.bs.modal', function() {
    		self.centerDialog($dlg);
    	});
	},
	
	/**
	 *select an address
	 */
	select: function($dlg, response, $container) {
		var self = this, addresses = response.addresses;
		
    	var sel = $('input[type=radio]:checked').val();
    	self.setSelectedAddress(response, sel);
    	self.populateFields(response);
    	self.toggleHearAbout(response.valid === true);
    	self.lastSel = sel;
    	
    	self.closeDialog($dlg, $container);
	},
	
	/**
	 * set the selected address to response object
	 */
	setSelectedAddress: function(response, sel) {
		var addresses = response.addresses;
		
    	response.address = addresses[sel];
    	response.company = response.address.company;
    	response.soldTo = response.address.soldTo;
    	
    	$('#contact-id').val(response.contact);
    	$('#sold-to-id').val(response.soldTo);
	},
	
	/**
	 * close dialog
	 */
	closeDialog: function($dlg, $container) {
		$container.empty();
    	$dlg.modal('hide');
	},
	
	/**
	 * build a table cell to display an address
	 */
	buildAddressCell: function(address, index) {
		
		var self = this;
		
		var $cell = $('<div class="address-container col-md-6' + (index%2 === 0 ? ' first' : '') + '"><div class="selection col-md-1"><input type="radio" name="wantedAddress" value="' + index + '"></div></div>');
		var $div = $('<div class="address col-md-11"/>').appendTo($cell);
		
		//Keep soldTo at the top
		$div.append(self.buildAddressItem(address.soldTo, 'sold-to'));
		
		for(var key in address) {
			if(key === 'soldTo') {
				continue;
			}
			var item = address[key];
			if(!item) continue;
			if(key === 'company') {
				$div.append(self.buildAddressItem(item.name));
				$div.append(self.buildAddressItem(item.name2));
			}else{
				$div.append(self.buildAddressItem(item));
			}
		}
				
		return $cell;
	},
	
	buildAddressItem: function(text, cls) {
		if(!cls) 
			cls = '';
		else
			cls = ' ' + cls;
		
		if (!text)
			text = '&nbsp;';
		
		return '<div class="address-item' + cls + '" title="' + text + '">' + text + '</div>';
	}
};

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

/**
 * Module for revealing the 'existing RS account customer inputs'
 */

/* eslint-disable */

module.exports = {
  init: function() {
    /* Setup the variables for the buttons and content to show hide */
    var self = this;
    self.content = $('#js-accountCustomerContent');
    self.btnOpen = $('#js-accountCustomerOpenBtn');
    self.inputs = self.content.find('input');
    self.btnActiveClass = 'active';

    /* Create event listener to open the inputs */
    self.btnOpen.on('click', function() {
      self.open();
    });

    if(self.inputs.val() !== '') {
      self.open();
    }
  },

  open: function() {
    var self = this;
    var btnClose  = $('#js-accountCustomerCloseBtn');

    self.content.slideDown(100);
    self.btnOpen.addClass(self.btnActiveClass);
    btnClose.removeClass(self.btnActiveClass);
      
    /* If the open function is triggered create the close function */
    function close() {
      self.content.addClass('in').slideUp(100);
      
      btnClose.addClass(self.btnActiveClass);
      self.btnOpen.removeClass(self.btnActiveClass);

      self.clearValidation();

      $(document).ajaxStop(function() {
        if(self.content.is(':hidden')) {
          self.clearValidation();  
        }
      });

      /* Remove the close event listener once No is clicked */
      btnClose.off('click');
    }

    /* Create the event listener only if the open function is triggered */
    btnClose.on('click', close);
  },

  clearValidation: function() {
    var self = this;

    // Hide the validation message
    self.content.find('.interactive-message-container').addClass('hidden');

    /* Find all the inputs insde the content and remove the value and any invalidation errors */
    self.inputs.each(function() {
      $(this).val('').removeClass('has-error verified').siblings('.text-error-icon, .text-verified-icon').addClass('hidden');
    });
  }
};


/***/ }),

/***/ 258:
/***/ (function(module, exports) {

if ($('#js-allMarketsContent').length !== 0) {

    module.exports = {
        init: function () {
            var self = this;

            self.businessContent = $('#js-allMarketsContent');

            self.btnYes = $('#js-businessOpenBtn');
            self.btnNo = $('#js-businessCloseBtn');
            self.btnActiveClass = 'active';
            self.label = $('#bussid');

            var isBusinessValue = $('#js-isbusiness').val();
            if (isBusinessValue === 'false') {
                self.btnNo.addClass(self.btnActiveClass);
                self.btnYes.removeClass(self.btnActiveClass);
                self.label.removeClass('required');
                self.btnNo.focus(); 
            } else if (isBusinessValue === 'true') {
                self.btnYes.addClass(self.btnActiveClass);
                self.btnNo.removeClass(self.btnActiveClass);
                self.label.addClass('required');
                self.btnYes.focus(); 
            }
    

            self.btnYes.on('click', function () {
                self.yes();
            });

            self.btnNo.on('click', function () {
                self.no();
            });

        },

        yes: function () {
            var self = this;

            self.businessContent = $('#js-allMarketsContent');
            self.btnYes = $('#js-businessOpenBtn');
            self.btnNo = $('#js-businessCloseBtn');
            self.btnActiveClass = 'active';
            self.label = $('#bussid');

            $('#js-isbusiness').prop('value', 'true');
            self.btnYes.addClass(self.btnActiveClass);
            self.btnNo.removeClass(self.btnActiveClass);
            self.label.addClass('required');

        },
        no: function () {
            var self = this;

            self.businessContent = $('#js-allMarketsContent');

            self.btnYes = $('#js-businessOpenBtn');
            self.btnNo = $('#js-businessCloseBtn');
            self.btnActiveClass = 'active';
            self.label = $('#bussid');

            $('#js-isbusiness').prop('value', 'false');
            self.btnNo.addClass(self.btnActiveClass);
            self.btnYes.removeClass(self.btnActiveClass);
            self.label.removeClass('required');
        }
    };
}



/***/ }),

/***/ 259:
/***/ (function(module, exports) {

if ($('#js-excludedMarketsContent').length !== 0) {

    module.exports = {
        init: function () {

            var self = this;

            self.businessContent = $('#js-excludedMarketsContent');
            self.label = $('#bussid');

            $('#js-isbusiness').prop('value', 'true');

            self.label.addClass('required');

        }
    };

}


/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports = {
    init: function () {
        /* Setup the variables for the buttons and content to show hide */
        var self = this;

        self.submit = $('#register-button');

        if ($('#js-businessOpenBtn').length !== 0) {
            // only send tracking if the locale is configured to ask if they are a business
            self.submit.on('click', function () {
                self.doTracking();
            });
        }
    },

    doTracking: function () {
        var _bootstrapper = window.Bootstrapper || {};
        var self = this;

        self.btnOpen = $('#js-accountCustomerOpenBtn');
        if(self.btnOpen.hasClass('active')) {
            self.haveAccount = 'Yes';
        }

        self.btnClose = $('#js-accountCustomerCloseBtn');
        if(self.btnClose.hasClass('active')) {
            self.haveAccount = 'No';
        }

        self.btnYes = $('#js-businessOpenBtn');
        if(self.btnYes.hasClass('active')) {
            self.business = 'Yes';
        }

        self.btnNo = $('#js-businessCloseBtn');
        if(self.btnNo.hasClass('active')) {
            self.business = 'No';
        }

        var formTracking = {
            'category': {
                'primaryCategory': 'formSubmission',
                'formSubmission': 'Success'
            },
            'attributes': {
                'formType': 'Registration',
                'haveAccount': self.haveAccount,
                'business': self.business,
                'formError': '',
                'valueStreamType': 'My Account'
            }
        };

       _bootstrapper.ensEvent.trigger('genericFormTracking', formTracking);
    }
};


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

var Constants = __webpack_require__(8);

/**
 * Helper methods 
 */
module.exports = {

	/**
	 * Ajax post method 
	 */
	ajaxPost: function(serviceUri, data, caller, params) {

		var cfg = {
			url: serviceUri,
			dataType: 'json',
			data:  JSON.stringify(data),
			contentType: 'application/json; charset=utf-8',
			cache: false,
			beforeSend: function() {
				if(caller && caller.beforeAjax) caller.beforeAjax();
			}
		};

		$.extend(cfg, params);

		return $.post(cfg)
			.fail(function() {
				console.info('calling ' + serviceUri + ' failed.');
			})
			.always(function() {
				if(caller && caller.afterAjax) caller.afterAjax();
			});
	},

	/**
	 * detect IE browser
	 */
	isIE: function() {
		var msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
		if (isNaN(msie)) {
			msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
		}
		return !isNaN(msie);
	},

	/**
	 * initialize every page
	 */
	initPage: function(conf) {		

		var self = this;

		if(typeof params === 'undefined') params = {};

		$.extend(params, Constants);
		$.extend(params, conf);

		$.extend(self, {
			ctxPath: params.ctxPath
		});

		var modules = params.modules;

		for(var key in modules) {
			var module = modules[key];
			if($.isFunction(module.init)) {
				module.init(params);
			}
		}
	},

	on: function(evtName, handler) {
		$(document).on(evtName, handler);
	},

	trigger: function(evtName, args) {
		$(document).trigger(evtName, args);
	},

	printDiv: function(windowId, w, h, fn) {// function to print the DIV element.
	    var DocumentContainer = document.getElementById(windowId);
	    var top = ($(window).height() - h)/2;
	    var left = ($(window).width() - w)/2; 
	    var WindowObject = window.open("", "PrintWindow",
	    			"width=" + w + ",height=" + w + ", top=" + top + ",left=" + left + ", toolbars=no,scrollbars=yes,status=no,resizable=yes");
	    WindowObject.document.writeln(DocumentContainer.innerHTML);

	    WindowObject.onload = function() {
	    	if(fn) {
		    	fn(WindowObject);
	    	}

	    	setTimeout(function() {
	    		WindowObject.print();
	    		WindowObject.close();
	    	}, 300);
		};

		WindowObject.document.close();
	    WindowObject.focus();
	},
	
	/**
	 * formats a product number.
	 * E.g. 202-467 -> 0202467
	 */
	formatPN: function(pn) {
		pn = pn.replace('-', '');

		while( 7 - pn.length > 0) {
			pn = '0' + pn;
		}

		return pn;
	},

	redirect: function(url) {
		this.getWindow().location.href = url; 
	},

	/**
	 * for mock purpose
	 */
	getWindow: function() {
		return window;
	},
	
	buildUrl: function(uri) {
		var self = this;

		return self.ctxPath + uri;
	},	

	/**
	* Calls `callback` once when `jQueryEl` is scrolled into view
	*/
	onVisibleOnce: function (jQueryEl, callback) {
		if (jQueryEl.length === 0) {
			return;
		}

		var self = this;
	    var scrollHandler = function () {
	        if (self.isCurrentlyVisible(jQueryEl)) {
	            $(document).off('scroll', scrollHandler);
	            callback();
	        }
	    }
	    $(document).scroll(scrollHandler);
	},

	/**
	* Returns `true` if `jQueryEl` is fully displayed within the viewport
	*/
	isCurrentlyVisible: function(jQueryEl) {
	    var boundingClientRect = jQueryEl[0].getBoundingClientRect();
	    var elTop = boundingClientRect.top;
	    var elBottom = boundingClientRect.bottom;

	    return (elTop >= 0) && (elBottom <= window.innerHeight);
	}
};


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

var _helper = __webpack_require__(23);

/**
 * Form module to handle form events
 */
module.exports = {
		
	/**
	 * Attach submit event to handle the form errors
	 * Not in use at the moment
	 */
	init: function(params) {
		var self = this, $form = params.$form;
		self.initPlaceholder($form);
	},
	
	/**
	 * set placeholders to text/password fields
	 */
	initPlaceholder: function($form) {

		var textSelector = 'input[type=text]' + ($.isFunction($.fn.placeholder) ? ':not([id^=shadow])' : '');
		var passwordSelector = 'input[type=password]';

		var self = this, 
			$textFields = $(textSelector, $form), 
			$passwordFields = $(passwordSelector, $form),
			$allFields = $(textSelector + ',' + passwordSelector, $form);

		// Put labels into placeholders for all browsers
		$allFields.each(function(index, field) {
			var label = _helper.getLabel(field);
			$(field).attr('placeholder', label);
		});

		// only for IE8/9. Refer to: js.jsp
		if($.isFunction($.fn.placeholder)) {
			$textFields.placeholder();
			self.initPasswordFielsPlaceholder($passwordFields);
		}
	},
	
	/**
	 * Initialize the placeholders of the password fields
	 */
	initPasswordFielsPlaceholder: function($passwordFields) {
		var self = this;

		$passwordFields.each(function(index, field) {
			var $field = $(field);
			var $ph = $field.siblings('.password-placeholder[for=' + field.id.replace('shadow-', '') + ']');

			$field.off('focus blur').on('focus blur', function(e) {
				var hide = e.type === 'focus' || $field.val().length > 0;
				$ph.toggleClass('hidden', hide);
				self.positionPlaceholder($field, $ph, hide);
			});

			// hook events
			$ph.off('click').on('click', function(e) {
				$field.trigger('focus');
			});

			var hide = $field.val().length > 0;
			// hide placeholder if password is not empty
			$ph.toggleClass('hidden', hide);
			// Calculate the position of the placeholder
			self.positionPlaceholder($field, $ph, hide);
		});
	},

	/**
	 * Calculate the position of the placeholder
	 */
	positionPlaceholder: function($field, $ph, hide) {
		if(!hide) {
			var left = $field.position().left;
			var offsetTop = $field.parent().height()/2 - $ph.height()/2;
			$ph.css({top: offsetTop, left: left+10});
		}
	}
};

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

/**
 * Country-region sub module
 */
module.exports = {
		
	/**
	 * initialize
	 */
	init: function(params) {
	
		// The regions object
	    var regionsMap = params.regionsMap;
		var numberOfCountries = params.numberOfCountries;
		var $contactAddress = $(params.regionField);
		var $country = $('#address\\.country');
		
		// Change the regions using this country code
		function changeRegion(countryCode) {
			
			// It could be that the region field is not a select if this isn't a CRM enabled locale
			// If that is the case then don't do anything here.
			if (!$contactAddress.is("select")) {
				return;
			}
			
			$contactAddress.empty();
	    	var optionsValues = '';
	        $.each(regionsMap[countryCode], function(i, region) {
	        	var $opt = $('<option value="' + region.code + '">' + region.name + '</option>');
	        	if(params.selectedRegion === region.code) {
	        		$opt.attr('selected', true);
	        	}
	        	$contactAddress.append($opt);
	        });
		}
		
		// Populate the region drop down with the current country
		changeRegion($country.val());
		
		// Select the correct region in the drop down
		if ($contactAddress.is("select")) {
			if (params.selectedRegion == '') {
				$contactAddress[0].selectedIndex = 0;
			}
			
			// When the country changes then update the regions by attaching a change listener to the country drop down
			$country.change(function(){
				changeRegion(this.value);
			});			
		}
	}
};

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/*
 * Constants 
 */
module.exports = {
  maxQuantity: 999999,

  qtyChangeEvt: 'rs.product.qty.changed',

  hlBreakPriceChangeEvt: 'rs.product.hl.price.changed',

  cartAddedEvt: 'rs.cart.added',

  popupShowEvt: 'rs.product.popup.show',

  popupShownEvt: 'rs.product.popup.shown',

  popupHideEvt: 'rs.product.popup.hide',

  qtyPlaceHolder: '##QTY##',

  modalTemplateUrl: '/modalTpl.jsp',

  addToCartUrl: '/services/shoppingBasket/lineItems/{articleId}/{quantity}',

  checkStockLevelUrl: '/services/product/getstock/{articleId}/{productId}/{quantity}',

  basketUrl: (typeof(params) !== "undefined") ? params.basketUrl : null,

  getPartsListUrl: '/services/product/partslist',

  savePartsListUrl: '/services/product/partslist/{partsListName}/{articleId}/{quantity}'
};


/***/ })

/******/ });


// WEBPACK FOOTER //
// registration.min.js